import { useEffect, useState, useCallback } from 'react';

// Navegação por teclado em listas filtradas por barra de pesquisa:
// ↑/↓ movem o destaque (com scroll automático), Enter seleciona, Esc limpa.
// Uso: const nav = useListKeyboardNav({ count, onSelect, resetKey });
//   <Input onKeyDown={nav.onKeyDown} />   <tr {...nav.rowProps(idx)}>
export const useListKeyboardNav = ({ count, onSelect, resetKey }) => {
  const [activeIdx, setActiveIdx] = useState(-1);

  useEffect(() => { setActiveIdx(-1); }, [resetKey]);
  useEffect(() => { if (activeIdx >= count) setActiveIdx(count - 1); }, [count, activeIdx]);

  useEffect(() => {
    if (activeIdx < 0) return;
    const el = document.querySelector(`[data-nav-idx="${activeIdx}"]`);
    if (el) el.scrollIntoView({ block: 'nearest' });
  }, [activeIdx]);

  const onKeyDown = useCallback((e) => {
    if (e.key === 'ArrowDown') {
      if (!count) return;
      e.preventDefault();
      setActiveIdx((i) => Math.min(i + 1, count - 1));
    } else if (e.key === 'ArrowUp') {
      if (!count) return;
      e.preventDefault();
      setActiveIdx((i) => Math.max(i - 1, 0));
    } else if (e.key === 'Enter') {
      if (activeIdx >= 0 && activeIdx < count) {
        e.preventDefault();
        onSelect?.(activeIdx);
      }
    } else if (e.key === 'Escape') {
      setActiveIdx(-1);
    }
  }, [count, activeIdx, onSelect]);

  const rowProps = useCallback((idx, extraClass = '') => ({
    'data-nav-idx': idx,
    'aria-selected': activeIdx === idx || undefined,
    className: `${extraClass} ${activeIdx === idx ? 'bg-blue-50 ring-2 ring-inset ring-blue-400' : ''}`.trim(),
    // mousemove (não mouseenter): o scroll automático não deve "roubar" o destaque para a linha sob o cursor parado
    onMouseMove: () => setActiveIdx((cur) => (cur === idx ? cur : idx)),
  }), [activeIdx]);

  return { activeIdx, setActiveIdx, onKeyDown, rowProps };
};
